export default __webpack_public_path__ + "static/media/github.363cb5ed.png";